// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-data-table[data-v-ae57b0fa] tbody tr:nth-child(odd){background-color:#ebedf3}.v-data-table[data-v-ae57b0fa] .v-data-table-header-mobile__wrapper{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.bottom-sticky[data-v-ae57b0fa]{position:sticky;bottom:0}.row-pointer[data-v-ae57b0fa] tbody tr{cursor:pointer}.row-pointer[data-v-ae57b0fa] tbody tr:active,.row-pointer[data-v-ae57b0fa] tbody tr:hover{background-color:#f5f5f5!important}", ""]);
// Exports
module.exports = exports;
